var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.returnBook}},[_c('span',[_vm._v(_vm._s(_vm.buttonText))]),_vm._v(" "),(_vm.loading)?_c('spinner',{staticStyle:{"display":"inline-block","margin-left":"0.5em"},attrs:{"size":'0.5em'}}):(_vm.errorMessage)?[_c('br'),_c('i',{staticClass:"u-dimmed"},[_vm._v(_vm._s(_vm.errorMessage))])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab3dd4b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnBookButton.vue
// module id = null
// module chunks = 